<template>
  <div class="line-chart-modal" ref="lineChartModalRef">
    <artmisads-modal
      :open="true"
      :title="props.title"
      :width="1200"
      :getContainer="() => lineChartModalRef"
      :destroyOnClose="true"
      :maskClosable="false"
      :footer="null"
      :onCancel="props.onCancleModal"
    >
        <div class="content">
          <div class="sp-head-content" v-if="props.pageType === 'sellerProduct' || props.pageType === 'publisherProduct' || props.pageType === 'publisherLink'">
            <span v-if="!props.itemInfo.productImageUrl"></span>
            <img v-else :src="props.itemInfo.productImageUrl" />
            <div class="text">
              <p>{{props.itemInfo.productTitle}}</p>
              <div class="flex">
                <span>{{props.itemInfo.productAsin}}</span>
                <span v-if="props.pageType === 'sellerProduct' && props.itemInfo.productBrand">{{ st('reports.lineChartModal.brandLabel') }} {{ props.itemInfo.productBrand }}</span>
                <span v-if="props.pageType === 'sellerProduct'">{{ st('reports.lineChartModal.marketplaceLabel') }} {{ props.marketplace }}</span>
              </div>
            </div>
          </div>
          <div class="brand-head-content" v-else-if="props.pageType === 'operatorBrand' || props.pageType === 'sellerBrand' || props.pageType === 'publisherBrand' || props.pageType === 'publisherBrandLink'">
            <span v-if="!props.itemInfo.brandLogoImageUrl"><em class="brand-name">{{ props.itemInfo.brandName }}</em></span>
            <img v-else :src="props.itemInfo.brandLogoImageUrl" />
            <div class="text">
              <p>{{props.itemInfo.brandName}}</p>
              <p class="biography" v-if="props.itemInfo.biography">{{props.itemInfo.biography}}</p>
            </div>
          </div>
          <div class="publisher-head-content" v-else-if="props.pageType === 'sellerPublisher'||props.pageType === 'operatorPublisher' ">
            <span v-if="!props.itemInfo.publisherHeadImageUrl"></span>
            <img v-else :src="props.itemInfo.publisherHeadImageUrl" />
            <div class="text">
              <p>{{props.itemInfo.publisherName}}</p>
            </div>
          </div>
          <div class="primary-head-content" v-else-if="props.pageType === 'trackingId'">
            <template v-if="props.itemInfo.primaryTrackingIds">
              <span>{{props.itemInfo.primaryTrackingId}}</span>
              <a href="javascript:void(0)" style="margin-left: 30px;" >{{ st('reports.lineChartModal.primaryId') }}</a>
            </template>
            <template v-else>
              <div>
                <span>{{props.itemInfo.subTrackingId}}</span>
                <a href="javascript:void(0)" style="margin-left: 30px;" >{{ st('reports.lineChartModal.subId') }}</a>
              <div>
                {{ st('reports.lineChartModal.primaryIdColon') }} {{ props.itemInfo.primaryTrackingId }}  
              </div>
              </div>
              
            </template>
          </div>
          
        </div>
        <div class="date" ref="dateRef">
          <artemisads-range-picker
            :allowClear="false"
            :value="hackValue || dateParams"
            @openChange="onOpenChange"
            :presets="rangePresets"
            :disabled-date="disabledDate"
            @change="onChangeDate"
            @calendarChange="onCalendarChange"
            :getPopupContainer="() =>dateRef"
          />
         
           <artemisads-segmented
               v-if="props.pageType === 'operatorBrand'
               ||props.pageType === 'operatorPublisher'
               ||props.pageType === 'sellerBrand'
               || props.pageType === 'sellerPublisher'"
              class="segmented"
              v-model:value="type"
              @change="handleChange"
              :options="segmentedOptions"
            />
           
            <div ref="exportRef" style="width: 150px;" v-if="props.pageType === 'operatorBrand'||props.pageType === 'operatorPublisher'|| props.pageType === 'sellerBrand'
               || props.pageType === 'sellerPublisher'"> 
            <a-dropdown :getPopupContainer="() => exportRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleExportClick">
                <a-menu-item key="all">{{ st('reports.performance.exportAllData') }}</a-menu-item>
                <a-menu-item key="filter">{{ st('reports.performance.exportWithFilters') }}</a-menu-item>
              </artmisads-dropdown-menu>
            </template>
            <artmisads-button-special style="display: flex;align-items: center;">
              <svg class="icon daochu" aria-hidden="true">
                <use xlink:href="#icon-daochu"></use>
              </svg>
              <span class="btn-text">{{ st('productDetail.export') }}</span>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou-xia-cu"></use>
              </svg>
            </artmisads-button-special>
          </a-dropdown>
            </div>
         
        </div>
        <div class="tags" v-if="type === SEGMENT_TOTAL">
          <a-spin :spinning="spinningFlag">
            <filterTag
            :setParams="setParams"
            :tagNumParams="tagNumParams"
            :marketplace="props.marketplace"
            :noNeedList="props.noNeedList"
            :defaultMetricName="props.defaultMetricName || 'clicks'"
          />
          </a-spin>
        </div>
      <a-spin :spinning="spinning">
      <div class="modal-chart" v-if="type === SEGMENT_TOTAL">
          <chart
            :showDate="true"
            :dataList="dataList"
            :width="1152"
            showYName="metricValue"
            :isPercent="params.metricName === 'acosAmount' || params.metricName === 'conversionsRate'"
            showXName="reportDateTimestamp"
            :lineColor="chartParams.lineColor"
            :lineBgOffsetTop="chartParams.lineBgOffsetTop"
            :lineBgOffsetZero="chartParams.lineBgOffsetZero"
            :showCurrent="false"
            :startTimestamp="params.startReportDateTimestamp"
            :endTimestamp="params.endReportDateTimestamp"
            :onClickBarChart="onClickBarChart"
            :metricName="params.metricName"
          />
      </div>
      <div class="modal-table" v-else>
        <lineChartTable 
           :activeTab="props.activeTab"
           :pageType="props.pageType"
           :marketplace="props.marketplace"
           :itemInfo="props.itemInfo"
           :params="params"
        />
      </div>
     </a-spin>
    </artmisads-modal>
  </div>
</template>
<script setup>
  import moment from 'moment';
  import { ref, onMounted, computed, watch } from "vue";
  import lineChartTable from '~/components/reports/lineChartTable.vue';
  
  import { RANGE_PRESETS } from '~/contants/reports';
  import { reportsApi, publisherReportsApi,publisherAdminApi } from '~/server/index';
  import { RESPORTS_TYPE_MAP } from '~/contants/reports';
  import filterTag from '~/components/reports/filterTag.vue';
  import chart from '~/components/reports/chart.vue';
  import { useSellerI18n } from '@/composables/useSellerI18n';

  const { st } = useSellerI18n();

  const SEGMENT_TOTAL = 'Total';
  const SEGMENT_PUBLISHER_DETAIL = 'Publisher Detail';
  const SEGMENT_BRAND_DETAIL = 'Brand Detail';

  const RANGE_PRESET_KEYS = [
    'reports.filterBar.presetLast7Days',
    'reports.filterBar.presetLast14Days',
    'reports.filterBar.presetLast30Days',
    'reports.filterBar.presetLast90Days',
    'reports.filterBar.presetLastYear',
  ];

  const rangePresets = computed(() =>
    RANGE_PRESETS.map((preset, i) => ({
      label: st(RANGE_PRESET_KEYS[i]),
      value: preset.value,
    })),
  );

  const props = defineProps({
  defaultMetricName: {
    type: String,
    default: ''
  },
  activeTab: {
    type: String,
    default: '0'
  },
  linkMd5: {
    type: String,
    default: ''
  },
  noNeedList: {
    type: Array,
    default: () => []
  },
  showlineChartModal: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  itemInfo: {
    type: Object,
    default: () => ({})
  },
  onCancleModal: {
    type: Function,
    default: () => {}
  },
  pageType: {
    type: String,
    default: ''
  },
  marketplace: {
    type: String,
    default: ''
  },
  trackingIdType: {
    type: String,
    default: ''
  },
 
});

  const segmentedOptions = computed(() => {
    // if (!props.pageType?.match?.('operator')) {
    //   return [];
    // }
    if (props.pageType === 'operatorPublisher'||props.pageType === 'sellerPublisher') {
      return [
        { label: st('reports.lineChartModal.segmentTotal'), value: SEGMENT_TOTAL },
        { label: st('reports.lineChartModal.segmentBrandDetail'), value: SEGMENT_BRAND_DETAIL },
      ];
    }
    return [
      { label: st('reports.lineChartModal.segmentTotal'), value: SEGMENT_TOTAL },
      { label: st('reports.lineChartModal.segmentPublisherDetail'), value: SEGMENT_PUBLISHER_DETAIL },
    ];
  });

  const dataList = ref([]);
  const type = ref(SEGMENT_TOTAL);
  const spinning = ref(false);
  const spinningFlag = ref(false);
  const lineChartModalRef = ref();
  const dates = ref();
  const hackValue = ref();
  const dateRef = ref();
  const exportRef = ref(null);

  const handleChange = () => {};


  const params = ref({
    marketplace: 'amazon.com',
    startReportDateTimestamp:props.itemInfo.startReportDateTimestamp || moment().subtract(1, 'month').valueOf(),
    endReportDateTimestamp: props.itemInfo.endReportDateTimestamp || moment().valueOf(),
    brandId: null,
    productId: null,
    metricName: props.defaultMetricName || 'clicks',
  })
// console.log(props.itemInfo,'props.itemInfo')
  const dateParams = ref([
    props.itemInfo.startReportDateTimestamp 
      ? moment(props.itemInfo.startReportDateTimestamp) 
      : moment().subtract(1, 'month'),
    props.itemInfo.endReportDateTimestamp 
      ? moment(props.itemInfo.endReportDateTimestamp) 
      : moment()
  ])

  const tagNumParams = ref({
    totalClicks: null,
    totalDetailPageViews: null,
    totalAddToCart: null,
    totalConversions: null,
    totalSalesAmount: null,
    totalDiscountedSalesAmount: null,
    totalBonusAmount: null,
    totalCommissionAndFeeAmount: null,
    lastUpdateAt: null
  });

  const chartParams = computed(() => {
    let lineColor, lineBgOffsetTop, lineBgOffsetZero, chartParamsData, itemData;
    itemData =  RESPORTS_TYPE_MAP[params.value.metricName];
    lineColor = itemData.lineColor;
    lineBgOffsetTop = itemData.lineBgOffsetTop;
    lineBgOffsetZero = itemData.lineBgOffsetZero;
    chartParamsData = { lineColor, lineBgOffsetTop, lineBgOffsetZero }
    return chartParamsData;
  })

  const disabledDate = current => {
      let notDate = false, tooLate = false, tooEarly = false;
    notDate = current.valueOf() > moment().valueOf();
    if (dates.value && dates.value.length) {
      tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') > 365;
      tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 365;
    }
    return notDate || tooEarly || tooLate;
  };

  const getList = async () => {
    spinning.value = true;
    let newparams = {...params.value}, res;
    newparams.marketplace = props.marketplace;
    if (newparams.metricName === 'acosAmount') {
      newparams.metricName = 'acos'
    }
    if (props.pageType === 'sellerProduct') {
      newparams.productId = props.itemInfo.productId;
      switch(props.activeTab){
        case '0':
          res = await reportsApi.getSellerCommissionReportsProductDailyMetric(newparams);
          break;
        case '1':
          res = await reportsApi.getSellerCommissionReportsProductDailyMetricAssociate(newparams);
          break;
        case '2':
          res = await reportsApi.getSellerCommissionReportsProductDailyMetricCc(newparams);
          break;
      }
    } else if (props.pageType === 'sellerBrand') {
      newparams.brandId = props.itemInfo.brandId;
      switch(props.activeTab){
        case '0':
          res = await reportsApi.getSellerCommissionReportsBrandDailyMetric(newparams);
          break;
        case '1':
          res = await reportsApi.getSellerCommissionReportsBrandDailyMetricAssociate(newparams);
          break;
        case '2':
          res = await reportsApi.getSellerCommissionReportsBrandDailyMetricCc(newparams);
          break;
      }
    } else if (props.pageType === 'sellerPublisher') {
      newparams.publisherId = props.itemInfo.publisherId;
      switch(props.activeTab){
        case '0':
          res = await reportsApi.getSellerCommissionReportsPublisherDailyMetric(newparams);
          break;
        case '1':
          res = await reportsApi.getSellerCommissionReportsPublisherDailyMetricAssociate(newparams);
          break;
        case '2':
          res = await reportsApi.getSellerCommissionReportsPublisherDailyMetricCc(newparams);
          break;
      }
    } else if (props.pageType === 'publisherProduct') {
      newparams.productId = props.itemInfo.productId;
      switch(props.activeTab){
        case '0':
          res = await publisherReportsApi.getPublisherCommissionReportsProductDailyMetric(newparams);
          break;
        case '1':
          res = await publisherReportsApi.getPublisherCommissionReportsProductDailyMetricAssociate(newparams);
          break;
        case '2':
          res = await publisherReportsApi.getPublisherCommissionReportsProductDailyMetricCc(newparams);
          break;
      }
    } else if (props.pageType === 'publisherBrand') {
      newparams.brandId = props.itemInfo.brandId;
      switch(props.activeTab){
        case '0':
          res = await publisherReportsApi.getPublisherCommissionReportsBrandDailyMetric(newparams);
          break;
        case '1':
          res = await publisherReportsApi.getPublisherCommissionReportsBrandDailyMetricAssociate(newparams);
          break;
        case '2':
          res = await publisherReportsApi.getPublisherCommissionReportsBrandDailyMetricCc(newparams);
          break;
      }
    } else if (props.pageType === 'publisherBrandLink') {
      newparams.brandId = props.itemInfo.brandId;
      newparams.trackingLinkMd5 = props.linkMd5;
      res = await publisherReportsApi.getPublisherCommissionReportsPerformanceDailyMetric(newparams);
    } else if (props.pageType === 'publisherLink') {
      switch(props.activeTab){
        case '0':
           newparams.trackingLinkMd5 = props.linkMd5;
          res = await publisherReportsApi.getPublisherCommissionReportsPerformanceDailyMetric(newparams);
          break;
        case '1':
          newparams.productId = props.itemInfo.productId;
          res = await publisherReportsApi.getPublisherCommissionReportsPerformanceDailyMetricAssociate(newparams);
          break;
      }

    }else if(props.pageType === 'trackingId'){
      newparams.primaryTrackingId = props.itemInfo.primaryTrackingId;
      newparams.subTrackingId = props.itemInfo.subTrackingId;
      const stat=props.itemInfo.stat
      res = await publisherReportsApi.getPublisherCommissionReportsTrackingIdDailyMetric({...newparams,stat});
    }else if(props.pageType === 'operatorProduct'){
      newparams.productId = props.itemInfo.productId;
        switch(props.activeTab){
        case '0':
         res = await publisherAdminApi.commissionReportsProductDailyMetric(newparams);
          break;
        case '1':
          res = await publisherAdminApi.associateCommissionReportsProductDailyMetric(newparams);
          break;
        case '2':
          res = await publisherAdminApi.commissionReportsProductDailyMetricCc(newparams);
          break;
      }
    }else if(props.pageType === 'operatorBrand'){
      newparams.brandId = props.itemInfo.brandId;
       switch(props.activeTab){
        case '0':
         res = await publisherAdminApi.commissionReportsBrandDailyMetric(newparams);
          break;
        case '1':
          res = await publisherAdminApi.associateCommissionReportsBrandDailyMetric(newparams);
          break;
        case '2':
          res = await publisherAdminApi.commissionReportsBrandDailyMetricCc(newparams);
          break;
      }
      // res = await publisherAdminApi.(newparams);
    }else if(props.pageType === 'operatorPublisher'){
      newparams.publisherId = props.itemInfo.publisherId;
      switch(props.activeTab){
        case '0':
         res = await publisherAdminApi.commissionReportsPublisherDailyMetric(newparams);
          break;
        case '1':
          res = await publisherAdminApi.associateCommissionReportsPublisherDailyMetric(newparams);
          break;
        case '2':
          res = await publisherAdminApi.commissionReportsPublisherDailyMetricCc(newparams);
          break;
      }
    }
     const { success, data } = res;

    if (success) {
      dataList.value = newparams.metricName === 'acos' || newparams.metricName === 'conversionsRate' ? data.map(item => {
        return {
          ...item,
          metricValue: (item.metricValue * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1')
        }
      }) : data;
      if(dataList.value.length==1){
        dataList.value.push(dataList.value[0])
      }
    }
  
    spinning.value = false;
  }
  const exportData = async () => {
    await getSellerCommissionReportsAgg();
    exportExcel(dataList.value, 'Commission Reports');
  }
  const onOpenChange = open => {
    if (open) {
      dates.value = [];
      hackValue.value = [];
    } else {
      hackValue.value = undefined;
    }
  };
  const onCalendarChange = val => {
    dates.value = val;
  };

  const setParams = obj => {
    const newObj = {...params.value, ...obj};
    params.value = newObj;
  }
   const handleExportClick = async ({ key }) => {
    let exportParams = {
      endReportDateTimestamp: moment().startOf('day').valueOf(),
      marketplace: props.marketplace,
      startReportDateTimestamp: moment().subtract(365, 'day').startOf('day').valueOf(),
    }, newExportParams = {}
    if (key === 'filter') {
      exportParams = { ...params.value }
    }
    for (let item in exportParams) {
      if (exportParams[item]) {
        newExportParams[item] = exportParams[item]
      }
    }

    let finalParams = {
      qs: newExportParams,
      fileName: `Brand-Reports-${moment().format('YYYY-MM-DD')}.csv`,
      platform: 'operatorV2',
    }
   
    switch (props.activeTab) {
      case '0':
        if(props.pageType === 'operatorBrand'){
          finalParams.qs.brandId = props.itemInfo.brandId || undefined;
          finalParams.fileName = `${props.itemInfo.brandName}-Attribution-Detail-${moment().format('YYYY-MM-DD')}.csv`
          publisherAdminApi.commissionReportsPublisherExport(finalParams)
        } 
        if(props.pageType === 'operatorPublisher'){
          finalParams.qs.publisherId = props.itemInfo.publisherId || undefined;
          finalParams.fileName = `${props.itemInfo.publisherName}-Attribution-Detail-${moment().format('YYYY-MM-DD')}.csv`
          publisherAdminApi.commissionReportsBrandExport(finalParams)
        }
        if(props.pageType === 'sellerBrand'){
          finalParams.qs.brandId = props.itemInfo.brandId || undefined;
          finalParams.fileName = `${props.itemInfo.brandName}-Attribution-Detail-${moment().format('YYYY-MM-DD')}.csv`
          reportsApi.exportCommissionPublisherReports(finalParams)
        }
        if(props.pageType === 'sellerPublisher'){
          finalParams.qs.publisherId = props.itemInfo.publisherId || undefined;
          finalParams.fileName = `${props.itemInfo.publisherName}-Attribution-Detail-${moment().format('YYYY-MM-DD')}.csv`
          reportsApi.exportCommissionBrandReports(finalParams)
        }
        break
      case '1':
         finalParams.platform='operator'
         if(props.pageType === 'operatorBrand'){
          finalParams.qs.brandId = props.itemInfo.brandId || undefined;
          finalParams.fileName = `${props.itemInfo.brandName}-Associate-Detail-${moment().format('YYYY-MM-DD')}.csv`
          publisherAdminApi.associateCommissionReportsPublisherExport(finalParams)
        } 
        if(props.pageType === 'operatorPublisher'){
          finalParams.qs.publisherId = props.itemInfo.publisherId || undefined;
          finalParams.fileName = `${props.itemInfo.publisherName}-Associate-Detail-${moment().format('YYYY-MM-DD')}.csv`
          publisherAdminApi.associateCommissionReportsBrandExport(finalParams)
        }
        if(props.pageType === 'sellerBrand'){
          finalParams.qs.brandId = props.itemInfo.brandId || undefined;
          finalParams.fileName = `${props.itemInfo.brandName}-Associate-Detail-${moment().format('YYYY-MM-DD')}.csv`
          reportsApi.associateCommissionReportsPublisherExport(finalParams)
        }
        if(props.pageType === 'sellerPublisher'){
          finalParams.qs.publisherId = props.itemInfo.publisherId || undefined;
          finalParams.fileName = `${props.itemInfo.publisherName}-Associate-Detail-${moment().format('YYYY-MM-DD')}.csv`
          reportsApi.exportCommissionPublisherReportsBrandAssociate(finalParams)
        }
        break
    }
  }

  const onChangeDate = val => {
    if (val) {
      dateParams.value = val;
      const dateTime = {
        startReportDateTimestamp: val[0].valueOf(),
        endReportDateTimestamp: val[1].valueOf(),
      };
      let newparams = {...params.value, ...dateTime};
      params.value = newparams;
    } else {
      dateParams.value = [];
    }
  }

  const getSellerCommissionReportsAgg = async () => {
    spinningFlag.value = true;
    let newparams = {...params.value}, res;
    newparams.marketplace = props.marketplace;
    
    if (props.pageType === 'sellerProduct') {
      newparams.productId = props.itemInfo.productId;
    } else if (props.pageType === 'sellerBrand') {
      newparams.brandId = props.itemInfo.brandId;
    } else if (props.pageType === 'sellerPublisher') {
      newparams.publisherId = props.itemInfo.publisherId;
    } else if (props.pageType === 'publisherProduct') {
      newparams.productId = props.itemInfo.productId;
    } else if (props.pageType === 'publisherBrand') {
      newparams.brandId = props.itemInfo.brandId;
      newparams.trackingLinkMd5 = props.linkMd5;
    } else if (props.pageType === 'publisherBrandLink') {
      newparams.brandId = props.itemInfo.brandId;
      newparams.trackingLinkMd5 = props.linkMd5;
    } else if (props.pageType === 'publisherLink') {
      newparams.trackingLinkMd5 = props.linkMd5;
      newparams.productId = props.itemInfo.productId;
    }else if(props.pageType === 'trackingId'){
      newparams.primaryTrackingId = props.itemInfo.primaryTrackingId;
      newparams.subTrackingId = props.itemInfo.subTrackingId;
    }else if(props.pageType === 'operatorProduct'){
      
      newparams.productId = props.itemInfo.productId;
    }else if(props.pageType === 'operatorPublisher'){
      newparams.publisherId = props.itemInfo.publisherId;
    }else if(props.pageType === 'operatorBrand'){
      newparams.brandId = props.itemInfo.brandId;
    }
    if (props.pageType.match('seller')) {
      switch(props.activeTab){
        case '0':
          res = await reportsApi.getSellerCommissionReportsAgg(newparams);
          break;
        case '1':
          res = await reportsApi.getSellerCommissionReportsAggAssociate(newparams);
          break;
        case '2':
          res = await reportsApi.getSellerCommissionReportsAggCc(newparams);
          break;
      }
    } else if (props.pageType.match('publisher')) {
      switch(props.activeTab){
        case '0':
          res = await publisherReportsApi.getPublisherCommissionReportsAgg(newparams);
          break;
        case '1':
          res = await publisherReportsApi.getPublisherCommissionReportsAggAssociate(newparams);
          break;
        case '2':
          res = await publisherReportsApi.getPublisherCommissionReportsAggCc(newparams);
          break;
      }
    }else if(props.pageType.match('operator')){
     switch(props.activeTab){
        case '0':
          res = await publisherAdminApi.commissionReportsAggPerformance(newparams);
          break;
        case '1':
         res = await publisherAdminApi.associateCommissionReportsAggPerformance(newparams);
          break;
        case '2':
          res = await publisherAdminApi.commissionReportsAggCc(newparams);
          break;
      }
     
    }
    if(props.pageType === 'trackingId'){
      const stat=props.itemInfo.stat
      res = await publisherReportsApi.getPublisherCommissionReportsTrackingIdAgg({...newparams,stat});
    }
  
    if(props.pageType.match('operator')){
       tagNumParams.value = res;
 
    }else{
   const { success, data } = res;
    if (success) {
      tagNumParams.value = data;
    }
    }
 
    spinningFlag.value = false;

  }

  watch(() => params.value.metricName, async () => {
    getList();
  });
  watch([() => params.value.startReportDateTimestamp, () => params.value.endReportDateTimestamp], async () => {
    getList();
    getSellerCommissionReportsAgg();
  });

  onMounted(() => {
    getList();
    getSellerCommissionReportsAgg();
  })

</script>
<style lang="less" scoped>
  .daochu {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          fill: var(--dark-1);
        }
           .btn-text {
          align-self: center;
          font-weight: 500;
          line-height: 20px;
          margin-right: 8px;
        }
.export-btn{
  display: flex;
  align-items: center;
  gap: 8px;
}
.modal-table{
  margin-top: 16px;
}
.line-chart-modal {
  position: relative;
.primary-head-content{
  padding: 16px;
    display: flex;
    border-radius: 8px;
    align-items: center;
    box-shadow: var(--disabled-box-shadow-5);
}
  .publisher-head-content,
  .brand-head-content,
  .sp-head-content {
    padding: 8px;
    display: flex;
    border-radius: 8px;
    align-items: center;
    box-shadow: var(--disabled-box-shadow-5);
    > img {
      height: 72px;
      flex: 0 0 72px;
      max-width: 72px;
      position: relative;
      border-radius: 8px;
      object-fit: contain;
    }
    > span {
      width: 72px;
      height: 72px;
      min-width: 72px;
      position: relative;
      border-radius: 8px;
      background: var(--bg-gray-2);
      display: flex;
      align-items: center;
    }
    .flex {
      gap: 20px;
      display: flex;
    }
  }
  .brand-name {
  margin: 0 auto;
  padding: 0 4px;
  max-width: 56px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 39px;
  font-weight: 600;
  line-height: 13px;
  text-align: center;
  color: var(--dark-4);
  letter-spacing: 0.3px;
  word-break: break-all !important;
}
  .sp-head-content {
    .text {
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
      > p {
        max-width: 1050px;
        font-weight: 600;
        font-size: 16px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 22px;
        white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
      }
      span {
        padding: 4px 8px;
        border-radius: 6px;
        box-sizing: border-box;
        background: var(--bg-gray-8);

        font-weight: 500;
        font-size: 12px;
        color: var(--dark-2);
        letter-spacing: 0.3px;
        line-height: 16px;
        margin-top: 8px;
      }
    }
  }
  .publisher-head-content,
  .brand-head-content {
    .text {
      min-width: 0;
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
      > p {
        max-width: 1050px;
        font-weight: 600;
        font-size: 16px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 22px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .biography {
        font-size: 14px;
        margin-top: 8px;
        line-height: 20px;
        font-weight: normal;
        color: var(--dark-3);
      }
    }
  }
  .date {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .tags {
    padding: 16px 0;
  }
}
</style>
